import { get } from '@itslearning/atlas/network/fetch';

export interface ParticipantItemModel {
    personId: number;
    displayName: string;
    extraInfo: string;
    pictureUrl: string;
}
export interface ParticipantsModel {
    participants: ParticipantItemModel[];
    totalCount: number;
}

export interface ParticipantGroupItemModel {
    groupId: number;
    title: string;
}
export interface ParticipantGroupModel {
    groups: ParticipantGroupItemModel[];
    totalCount: number;
}

export type GetParticipantsFn = (pageIndex: number, pageSize: number, searchText?: string) => Promise<ParticipantsModel>;
export type GetParticipantGroupsFn = (pageIndex: number, pageSize: number, searchText?: string) => Promise<ParticipantGroupModel>;
export type GetItemsFn = (pageIndex: number, pageSize: number, searchText?: string) => Promise<{ totalCount: number; items: { id: number; value: object; checked?: boolean }[] }>;

export interface ParticipantSelectorSettings {
    groupsEnabled: boolean;
    getParticipantsFn: GetParticipantsFn;
    getGroupsFn: GetParticipantGroupsFn;
    addParticipantsLinkUrl: string;
    addGroupLinkUrl: string;
}

/**
 * Get participants data function
 */
export function getParticipantsFnFactory(courseId: number): GetParticipantsFn {
    return (pageIndex, pageSize, searchText) => {
        const params = new URLSearchParams();
        if (searchText) {
            params.append('search', searchText);
        }
        if (pageIndex) {
            params.append('pageIndex', pageIndex.toString());
        }
        if (pageSize) {
            params.append('pageSize', pageSize.toString());
        }

        const queryString = params.toString();
        const url = `/restapi/personal/courses/${courseId}/students/v1${queryString ? `?${queryString}` : ''}`;

        return get(url, getBaseOptions());
    };
}

/**
 * Get groups data function
 */
export function getGroupsFnFactory(courseId: number): GetParticipantGroupsFn {
    return (pageIndex, pageSize, searchText) => {
        const params = new URLSearchParams();
        if (searchText) {
            params.append('search', searchText);
        }
        if (pageIndex) {
            params.append('pageIndex', pageIndex.toString());
        }
        if (pageSize) {
            params.append('pageSize', pageSize.toString());
        }

        const queryString = params.toString();
        const url = `/restapi/personal/courses/${courseId}/participantgroups/v1${queryString ? `?${queryString}` : ''}`;

        return get(url, getBaseOptions());
    };
}

/**
 * Course settings factory
 */
export function participantsCourseSettingsFactory(courseId: number): ParticipantSelectorSettings {
    return {
        groupsEnabled: true,
        addParticipantsLinkUrl: `/CourseParticipantsV2/AddParticipants?CourseID=${courseId}&selectedTabIndex=0`,
        addGroupLinkUrl: `/CourseParticipantsV2?CourseID=${courseId}&selectedTabIndex=1`,
        getParticipantsFn: getParticipantsFnFactory(courseId),
        getGroupsFn: getGroupsFnFactory(courseId),
    };
}

/**
 * Returns the base fetch options for API requests
 */
function getBaseOptions(): {mode: string, credentials: string, headers: object} {
    return {
        mode: 'cors',
        credentials: 'include',
        headers: {
            'X-Response-Case': 'camel'
        }
    };
}
